import { useTemplate } from '../../../../../features/template/TemplateProvider';
import { ButtonPest } from '../../../../../utils/Button';

function BillingRow({ invoiceData }) {
    const { openModal } = useTemplate();
    return (
        <div className="flex flex-col gap-3">
            <div className="mb-1">
                <h2 className="text-primary text-xl font-normal">Billing</h2>
            </div>
            <span>
                <ButtonPest
                    title="Receive Payment"
                    onClick={() => openModal('payment-receive')}
                    disabled={
                        invoiceData?.amountDue === 0 ||
                        invoiceData?.status === 'canceled' ||
                        invoiceData?.isQuotation === true
                    }
                />
            </span>
            {invoiceData?.isQuotation === true ? (
                <span className="text-warning">
                    Warning: This is a quotation. You need to convert it to an invoice to receive
                    payment.
                </span>
            ) : null}
        </div>
    );
}

export default BillingRow;
